export const REVIEWS = [
  {
    name: "Trattoria Da Marco",
    city: "Verona",
    rating: 5,
    quote:
      "Aggiorno il menù dal telefono in un attimo. I clienti inquadrano il cubo e trovano tutto, allergeni compresi. Eleganza e praticità insieme.",
  },
  {
    name: "Osteria Il Girasole",
    city: "Bologna",
    rating: 5,
    quote:
      "Basta ristampe: cambio i piatti del giorno quando voglio. Il totem all'ingresso attira davvero l'attenzione dei passanti.",
  },
  {
    name: "Bar Centrale",
    city: "Milano",
    rating: 5,
    quote:
      "Le traduzioni automatiche ci hanno salvato con i turisti. Menù bello da vedere e velocissimo da consultare.",
  },
  {
    name: "Ristorante La Perla",
    city: "Napoli",
    rating: 5,
    quote:
      "Installazione semplice e assistenza impeccabile. Il Cube Luminos sui tavoli fa un figurone con gli ospiti.",
  },
];

export const FAQS = [
  {
    q: "Come funziona la piattaforma?",
    a: "Crei il tuo account, aggiungi menù, categorie e piatti dal telefono o dal computer. Ogni locale ha una pagina menù pubblica collegata al QR dei prodotti fisici (cubi, totem, piastre). Le modifiche sono online in tempo reale.",
  },
  {
    q: "Cosa include il piano gratuito rispetto a quello a pagamento?",
    a: "Con il piano gratuito provi la piattaforma e crei il tuo menù digitale. Il piano completo aggiunge funzioni avanzate come traduzioni automatiche, temi personalizzati, menù del giorno e la pubblicazione collegata ai prodotti fisici, con supporto dedicato.",
  },
  {
    q: "Quanto costa?",
    a: "L'abbonamento alla piattaforma parte da 25€ al mese, con addebito automatico su carta o SEPA. Puoi iniziare gratis e passare al piano completo quando vuoi. I prodotti fisici (cubi, totem, insegne) sono su preventivo in base alle tue esigenze.",
  },
  {
    q: "Come funziona l'installazione dei Cubetti fisici?",
    a: "Ricevi i tuoi Cubetti già configurati con il QR collegato al tuo menù. Ti basta posizionarli su tavoli, bancone o ingresso: nessun cablaggio complesso e nessuna configurazione tecnica da parte tua.",
  },
  {
    q: "Quanto tempo serve per attivare un menù?",
    a: "In genere pochi minuti: importi il menù (anche da un PDF esistente), rivedi le categorie e pubblichi. Se preferisci, possiamo preparare noi il primo menù per te.",
  },
  {
    q: "Serve competenza tecnica?",
    a: "No. L'editor è pensato per essere usato dal telefono, con trascinamento e anteprima immediata. Se hai bisogno, siamo a disposizione per assisterti in ogni fase.",
  },
];
